import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toastUtil } from '../../utils/toast'
import AdminSidebar from '../components/AdminSidebar'

type ToastType = 'success' | 'error' | 'warning' | 'info'

interface ToastEntry {
  type: ToastType
  msg: string
}

// 앱에서 실제 쓰는 토스트 문구 전수 (동적 ${...}은 샘플 값으로 대체).
// utils/toast.tsx의 toastUtil 호출을 전수 추출·중복제거한 목록.
const SUCCESS: string[] = [
  '3곳이 추가됐어요 (중복 제외)',
  '8곳을 가져왔어요',
  '10곳 중 8곳을 가져왔어요',
  '계정이 삭제되었습니다',
  '계정이 활성화되었습니다',
  '공유 링크가 복사되었습니다',
  '공지사항이 삭제되었습니다',
  '공지사항이 생성되었습니다',
  '공지사항이 수정되었습니다',
  '기본 리뷰 카테고리가 삭제되었습니다',
  '기본 리뷰 카테고리가 생성되었습니다',
  '기본 리뷰 카테고리가 수정되었습니다',
  '댓글이 삭제되었습니다',
  '댓글이 수정되었습니다',
  '댓글이 작성되었습니다',
  '리뷰 키워드가 삭제되었습니다',
  '리뷰 키워드가 생성되었습니다',
  '리뷰 키워드가 수정되었습니다',
  '리뷰가 삭제되었습니다',
  '리뷰가 저장되었습니다',
  '멤버가 수정되었습니다',
  '본인인증이 완료되었습니다',
  '비밀번호가 변경되었습니다',
  '비밀번호가 재설정되었습니다',
  '사용 가능한 아이디입니다',
  '사용 가능한 이메일입니다',
  '사용자 정보가 수정되었습니다',
  '사용자가 삭제되었습니다',
  '선택하신 장소가 저장되었습니다',
  '신고가 접수되었습니다',
  '이메일이 복사되었습니다',
  '이미 리스트에 있는 장소예요',
  '장소 정보가 수정되었습니다',
  '장소 카테고리가 삭제되었습니다',
  '장소 카테고리가 생성되었습니다',
  '장소 카테고리가 수정되었습니다',
  '장소가 삭제되었습니다',
  '제안이 완료되었습니다',
  '주소가 복사되었습니다',
  '지도 설정이 저장되었습니다',
  '카테고리가 추가되었습니다',
  '커버 이미지가 변경되었습니다',
  '팔로우 신청이 완료되었습니다',
  '팔로우 요청이 취소되었습니다',
  '팔로잉이 해제되었습니다',
  '프로필이 수정되었습니다',
  '플레이트리스트가 삭제되었습니다',
  '플레이트리스트가 수정되었습니다',
  '플레이트리스트에서 나갔습니다',
]

const WARNING: string[] = [
  '1인당 가격대를 선택해주세요',
  '3개 이상 가게에 리뷰를 작성하신 후 수정할 수 있습니다',
  '점수 순서는 평점 정렬 상태에서만 저장할 수 있습니다',
  '제안 내용은 최대 500자까지 가능합니다',
  '제안 내용을 입력해주세요',
  '최대 10장까지 추가 가능해 일부만 추가되었습니다',
  '최대 10장까지 추가할 수 있습니다',
  '키워드를 하나 이상 선택해주세요',
]

const INFO: string[] = [
  '가져올 장소가 없어요',
  '기록할 장소를 먼저 선택해주세요',
  '본인인증이 취소되었습니다',
  '이미 확인 완료된 아이디입니다',
  '이미 확인 완료된 이메일입니다',
  '이미 확인 중입니다',
  '현재 사용 중인 아이디입니다',
  '현재 사용 중인 이메일입니다',
]

const ERROR: string[] = [
  'SMS 앱을 열 수 없습니다',
  '가게 정보를 불러오는데 실패했습니다',
  '가게를 선택해주세요',
  '검색 중 오류가 발생했습니다',
  '계정 삭제 중 오류가 발생했습니다',
  '공유 링크 복사에 실패했습니다',
  '공지사항 목록을 불러오는데 실패했습니다',
  '공지사항 삭제 중 오류가 발생했습니다',
  '광고성 푸시 알림 동의 변경에 실패했습니다',
  '기본 리뷰 카테고리 목록을 불러오는데 실패했습니다',
  '네이버 로그인 인증 정보를 받을 수 없습니다',
  '네트워크 오류가 발생했습니다',
  '닉네임을 입력해주세요',
  '다음 비교를 진행할 수 없습니다',
  '댓글 삭제 중 오류가 발생했습니다',
  '댓글 좋아요 처리 중 오류가 발생했습니다',
  '로그아웃 중 오류가 발생했습니다',
  '리뷰 목록을 불러오는데 실패했습니다',
  '리뷰 삭제 중 오류가 발생했습니다',
  '리뷰 저장에 실패했습니다',
  '리뷰 정보를 불러오는데 실패했습니다',
  '리뷰 키워드 목록을 불러오는데 실패했습니다',
  '리뷰 키워드 삭제 중 오류가 발생했습니다',
  '리뷰를 불러오는데 실패했습니다',
  '리소스를 찾을 수 없습니다',
  '발송 대상 수를 불러오지 못했습니다',
  '본문을 입력해주세요',
  '북마크 카테고리 정보를 불러오는데 실패했습니다',
  '비교 가게 정보를 불러오는데 실패했습니다',
  '사용자 리스트를 불러오는데 실패했습니다',
  '사용자 목록을 불러오는데 실패했습니다',
  '사용자 정보를 불러오는데 실패했습니다',
  '사용자 프로필을 불러오는데 실패했습니다',
  '사진을 불러오지 못했습니다. 잠시 후 다시 시도해주세요',
  '상세 설명을 입력해주세요',
  '상호명을 입력해주세요',
  '서버 오류가 발생했습니다',
  '신고 목록을 불러오는데 실패했습니다',
  '신고 사유를 선택해주세요',
  '아이디와 비밀번호를 입력해주세요',
  '애플 로그인은 iOS에서만 사용 가능합니다',
  '앱으로 실행해주세요',
  '연락처 연동 동의 변경에 실패했습니다',
  '연락처 연동은 앱에서만 가능합니다',
  '오류가 발생했습니다',
  '요청 처리 중 오류가 발생했습니다',
  '위치 권한을 허용해주세요',
  '위치를 가져올 수 없습니다',
  '이메일 복사에 실패했습니다',
  '이미 제출 중입니다',
  '이미지 파일만 업로드 가능합니다',
  '입력 값을 확인해주세요',
  '입력 정보를 확인해주세요',
  '장소 등록에 실패했습니다',
  '장소 목록을 불러오는데 실패했습니다',
  '장소 정보를 찾을 수 없습니다',
  '장소 제안 목록을 불러오는데 실패했습니다',
  '장소 카테고리 목록을 불러오는데 실패했습니다',
  '장소명을 입력해주세요',
  '제목을 입력해주세요',
  '주소 복사에 실패했습니다',
  '지도 설정을 불러오는데 실패했습니다',
  '지역을 입력해주세요',
  '처리 중입니다',
  '카테고리 이름을 입력해주세요',
  '카테고리 정보를 불러오는데 실패했습니다',
  '카테고리 코드를 입력해주세요',
  '커버 이미지를 선택해주세요',
  '클러스터 해제 줌 레벨은 14에서 21 사이로 입력해주세요',
  '클러스터 해제 줌 레벨은 정수로 입력해주세요',
  '키워드 제안 목록을 불러오는데 실패했습니다',
  '탈퇴한 계정입니다',
  '파일 크기는 5MB 이하여야 합니다',
  '프로필 공개 설정 변경에 실패했습니다',
  '프론트엔드 URL을 가져올 수 없습니다',
  '플레이트리스트 이름을 입력해주세요',
  '플레이트리스트를 불러오는데 실패했습니다',
  '휴대폰 번호를 입력해주세요',
]

const SECTIONS: { type: ToastType; title: string; color: string; list: string[] }[] = [
  { type: 'success', title: '성공 (success)', color: '#2E7D32', list: SUCCESS },
  { type: 'warning', title: '경고 (warning)', color: '#B26A00', list: WARNING },
  { type: 'info', title: '안내 (info)', color: '#1565C0', list: INFO },
  { type: 'error', title: '오류 (error)', color: '#C62828', list: ERROR },
]

const AdminToastPreview: React.FC = () => {
  const navigate = useNavigate()
  const [customType, setCustomType] = useState<ToastType>('success')
  const [customMsg, setCustomMsg] = useState('테스트 토스트입니다')

  useEffect(() => {
    const adminToken = localStorage.getItem('admin_token')
    if (!adminToken) {
      navigate('/admin/login')
    }
  }, [navigate])

  const handleLogout = () => {
    localStorage.removeItem('admin_token')
    navigate('/admin/login')
  }

  const fire = (type: ToastType, msg: string) => {
    toastUtil[type](msg)
  }

  // 순차 재생: 각 토스트를 1.2s 간격으로 차례로 표시
  const playSequence = async (entries: ToastEntry[]) => {
    for (const e of entries) {
      fire(e.type, e.msg)
      await new Promise((r) => setTimeout(r, 1200))
    }
  }

  const allEntries: ToastEntry[] = SECTIONS.flatMap((s) =>
    s.list.map((msg) => ({ type: s.type, msg }))
  )

  const totalCount = allEntries.length

  return (
    <div className="flex min-h-screen bg-backgroundColorBg2">
      <AdminSidebar />

      <div className="flex-1 flex flex-col">
        <header className="bg-white border-b border-brandPrimary-10% sticky top-0 z-10">
          <div className="px-24px py-16px flex items-center justify-end">
            <button
              onClick={handleLogout}
              className="text-style-button2 text-textColorText2 hover:text-brown-80%-main transition-colors"
            >
              로그아웃
            </button>
          </div>
        </header>

        <main className="flex-1 px-24px py-32px">
          <div className="max-w-[900px]">
            <div className="flex items-center justify-between mb-24px">
              <h2 className="text-style-title2 text-textColorText2">
                토스트 미리보기{' '}
                <span className="text-textColorText2">({totalCount}종)</span>
              </h2>
              <button
                type="button"
                onClick={() => playSequence(allEntries)}
                className="py-10px px-20px bg-4B3621-80% text-white rounded-8px text-style-button2 hover:bg-4B3621-80%-70% transition-colors"
              >
                전체 순차 재생
              </button>
            </div>

            {/* 커스텀 테스터 */}
            <div className="bg-white rounded-16px shadow-sm p-24px mb-32px">
              <h3 className="text-style-labelL text-textColorText2 mb-16px">
                직접 입력해서 미리보기
              </h3>
              <div className="flex flex-wrap items-center gap-12px">
                <select
                  value={customType}
                  onChange={(e) => setCustomType(e.target.value as ToastType)}
                  className="py-10px px-12px rounded-8px border border-brandPrimary-10% text-style-body2"
                >
                  <option value="success">success</option>
                  <option value="error">error</option>
                  <option value="warning">warning</option>
                  <option value="info">info</option>
                </select>
                <input
                  type="text"
                  value={customMsg}
                  onChange={(e) => setCustomMsg(e.target.value)}
                  placeholder="메시지 입력"
                  className="flex-1 min-w-[220px] py-10px px-12px rounded-8px border border-brandPrimary-10% text-style-body2"
                />
                <button
                  type="button"
                  onClick={() => customMsg.trim() && fire(customType, customMsg)}
                  className="py-10px px-20px bg-4B3621-80% text-white rounded-8px text-style-button2 hover:bg-4B3621-80%-70% transition-colors"
                >
                  표시
                </button>
              </div>
            </div>

            {/* 유형별 전체 목록 */}
            {SECTIONS.map((section) => (
              <div
                key={section.type}
                className="bg-white rounded-16px shadow-sm p-24px mb-24px"
              >
                <div className="flex items-center justify-between mb-16px">
                  <h3
                    className="text-style-labelL font-bold"
                    style={{ color: section.color }}
                  >
                    {section.title} · {section.list.length}종
                  </h3>
                  <button
                    type="button"
                    onClick={() =>
                      playSequence(
                        section.list.map((msg) => ({ type: section.type, msg }))
                      )
                    }
                    className="py-8px px-16px rounded-8px text-style-button2 border border-brandPrimary-10% text-textColorText2 hover:bg-backgroundColorBg2 transition-colors"
                  >
                    이 유형 순차 재생
                  </button>
                </div>
                <div className="flex flex-wrap gap-8px">
                  {section.list.map((msg, i) => (
                    <button
                      key={i}
                      type="button"
                      onClick={() => fire(section.type, msg)}
                      title={msg}
                      className="py-8px px-12px rounded-8px border text-style-body2 text-left text-textColorText2 hover:bg-backgroundColorBg2 transition-colors"
                      style={{ borderColor: section.color + '55' }}
                    >
                      {msg.replace(/\n/g, ' ⏎ ')}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  )
}

export default AdminToastPreview
